import { FC } from "react";

import Image from "@/components/ui/Image/Image";
import useMediaQuery from "@/hooks/useMediaQuery";
import { EditorialModuleImage } from "@/types";

const TiledBlockV3: FC<{ items: EditorialModuleImage[] }> = ({ items }) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  return (
    <>
      <div className="grid grid-cols-2 h-full w-full">
        <div className="col-span-1 grid grid-cols-1 pr-xxs">
          <Image
            src={isMobile ? items[0].mobileImage?.url ?? items[0].image!.url : items[0].image!.url}
            width={543}
            height={267}
            className="w-full h-full rounded-lg aspect-2-1"
            alt={items[0].image!.title}
          />
        </div>
        <div className="col-span-1 grid grid-cols-1 pl-xxs">
          <Image
            src={isMobile ? items[1].mobileImage?.url ?? items[1].image!.url : items[1].image!.url}
            width={543}
            height={267}
            className="w-full h-full rounded-lg aspect-2-1"
            alt={items[1].image!.title}
          />
        </div>
      </div>
    </>
  );
};
export default TiledBlockV3;
